// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Topbar_topbar__lz\\+So {
  position: sticky;
  top: 0;
  z-index: 20;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 16px 16px 0;
  margin-bottom: 24px;
  font-family: "Inter Tight";
  background: rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}

.Topbar_left__JY1XN,
.Topbar_right__S\\+jT9 {
  display: flex;
  align-items: center;
  min-width: 0;
}

.Topbar_left__JY1XN {
  gap: 8px;
  flex: 1 1;
}

.Topbar_right__S\\+jT9 {
  gap: 6px;
  flex-shrink: 0;
}

.Topbar_menuToggle__PhqUB {
  display: none;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  flex-shrink: 0;
  border: none;
  border-radius: 50%;
  background: transparent;
  color: #6f7173;
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease;
}
.Topbar_menuToggle__PhqUB:hover {
  background: #f9f8f7;
  color: #0a0a0a;
}

.Topbar_breadcrumb__gh-PJ {
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
  overflow: hidden;
}

.Topbar_breadcrumbHome__4GDod {
  display: inline-flex;
  align-items: center;
  color: #1b3a34;
  flex-shrink: 0;
}

.Topbar_breadcrumbSep__Wgn2I {
  width: 3px;
  height: 3px;
  border-radius: 50%;
  background: #a3a3a3;
  flex-shrink: 0;
}

.Topbar_breadcrumbItem__rUG9Z,
.Topbar_breadcrumbLink__ZKrC1 {
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  color: #737373;
  text-decoration: none;
  white-space: nowrap;
}

.Topbar_breadcrumbLink__ZKrC1:hover {
  color: #0a0a0a;
}

.Topbar_breadcrumbCurrent__siwQT {
  color: #0a0a0a;
  overflow: hidden;
  text-overflow: ellipsis;
}

.Topbar_action__fWuOa {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 0 8px;
  border: none;
  border-radius: 4px;
  background: transparent;
  color: #1b3a34;
  font-family: inherit;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease;
}
.Topbar_action__fWuOa svg {
  color: #1b3a34;
  transition: color 0.15s ease;
}
.Topbar_action__fWuOa:hover {
  background: #f9f8f7;
  color: #17322d;
}
.Topbar_action__fWuOa:hover svg {
  color: #17322d;
}

.Topbar_updated__0yZi9 {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 0 8px;
  color: #737373;
  font-size: 12px;
  font-weight: 500;
  white-space: nowrap;
}
.Topbar_updated__0yZi9 svg {
  color: #6f7173;
}

.Topbar_actionLabel__P\\+Ti3 {
  white-space: nowrap;
}

.Topbar_bellWrap__mtyDC {
  position: relative;
  display: inline-flex;
}

.Topbar_bellBadge__2UeDk {
  position: absolute;
  top: -5px;
  right: -6px;
  min-width: 15px;
  height: 15px;
  padding: 0 3px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 9999px;
  background: #ff5a00;
  color: #fff;
  font-size: 9px;
  font-weight: 700;
  line-height: 1;
}

@media (max-width: 1139.98px) {
  .Topbar_menuToggle__PhqUB {
    display: inline-flex;
  }
  .Topbar_actionLabel__P\\+Ti3 {
    display: none;
  }
  .Topbar_updated__0yZi9 {
    display: none;
  }
  .Topbar_topbar__lz\\+So {
    border-radius: 0;
    padding: 16px 16px 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/layouts/PortalLayout/Topbar.module.scss","webpack://./src/layouts/PortalLayout/tokens.scss"],"names":[],"mappings":"AAQA;EACE,gBAAA;EACA,MAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SCuCmB;EDtCnB,oBAAA;EACA,mBAAA;EACA,0BCmDS;EDlDT,oCAAA;EACA,2BAAA;EACA,mCAAA;EACA,2BC2BmB;ED1BnB,4BC0BmB;ADjCrB;;AAUA;;EAEE,aAAA;EACA,mBAAA;EACA,YAAA;AAPF;;AAUA;EACE,QCmBmB;EDlBnB,SAAA;AAPF;;AAUA;EACE,QCamB;EDZnB,cAAA;AAPF;;AAWA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,YAAA;EACA,kBAAA;EACA,uBAAA;EACA,cCxBmB;EDyBnB,eAAA;EACA,mDAAA;AARF;AAUE;EACE,mBCxBiB;EDyBjB,cCpCiB;AD4BrB;;AAaA;EACE,aAAA;EACA,mBAAA;EACA,QChBmB;EDiBnB,YAAA;EACA,gBAAA;AAVF;;AAaA;EACE,oBAAA;EACA,mBAAA;EACA,cC1DmB;ED2DnB,cAAA;AAVF;;AAaA;EACE,UAAA;EACA,WAAA;EACA,kBAAA;EACA,mBC1DmB;ED2DnB,cAAA;AAVF;;AAaA;;EAEE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cCpEmB;EDqEnB,qBAAA;EACA,mBAAA;AAVF;;AAaA;EACE,cC3EmB;ADiErB;;AAaA;EACE,cC/EmB;EDgFnB,gBAAA;EACA,uBAAA;AAVF;;AAcA;EACE,oBAAA;EACA,mBAAA;EACA,QC5DmB;ED+DnB,cAAA;EACA,YAAA;EACA,kBCrEmB;EDsEnB,uBAAA;EACA,cCrGmB;EDsGnB,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,mDAAA;AAbF;AAeE;EACE,cC7GiB;ED8GjB,4BAAA;AAbJ;AAgBE;EACE,mBCjGiB;EDkGjB,cClHiB;ADoGrB;AAgBI;EACE,cCrHe;ADuGrB;;AAmBA;EACE,oBAAA;EACA,mBAAA;EACA,QC5FmB;ED6FnB,cAAA;EACA,cCzHmB;ED0HnB,eAAA;EACA,gBAAA;EACA,mBAAA;AAhBF;AAkBE;EACE,cC1HiB;AD0GrB;;AAoBA;EACE,mBAAA;AAjBF;;AAoBA;EACE,kBAAA;EACA,oBAAA;AAjBF;;AAoBA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;EACA,cAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,qBAAA;EACA,mBCpImB;EDqInB,WAAA;EACA,cAAA;EACA,gBAAA;EACA,cAAA;AAjBF;;AAqBA;EACE;IACE,oBAAA;EAlBF;EAsBA;IACE,aAAA;EApBF;EAuBA;IACE,aAAA;EArBF;EAwBA;IACE,gBAAA;IACA,oBAAA;EAtBF;AACF","sourcesContent":["@import \"./tokens\";\n\n// =============================================================================\n// PortalLayout · Topbar\n// Slim header row inside the content panel: breadcrumb (left) + actions (right).\n// Sticky + glass, matching the Figma \"Status Bar\" row.\n// =============================================================================\n\n.topbar {\n  position: sticky;\n  top: 0;\n  z-index: 20;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: $lux-space-3;\n  padding: $lux-space-4 $lux-space-4 0; // 16px from the upper edge + left/right (Figma header inset)\n  margin-bottom: 24px; // 24px gap before content (Figma: header bottom y32 → title y56)\n  font-family: $lux-font;\n  background: rgba(255, 255, 255, 0.8);\n  backdrop-filter: blur(20px);\n  -webkit-backdrop-filter: blur(20px);\n  border-top-left-radius: $lux-radius-lg;\n  border-top-right-radius: $lux-radius-lg;\n}\n\n.left,\n.right {\n  display: flex;\n  align-items: center;\n  min-width: 0;\n}\n\n.left {\n  gap: $lux-space-2;\n  flex: 1;\n}\n\n.right {\n  gap: $lux-space-1;\n  flex-shrink: 0;\n}\n\n// ── Mobile menu toggle (hidden on desktop) ────────────────────────────────────\n.menuToggle {\n  display: none;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  height: 36px;\n  flex-shrink: 0;\n  border: none;\n  border-radius: 50%;\n  background: transparent;\n  color: $lux-icon-secondary;\n  cursor: pointer;\n  transition: background 0.15s ease, color 0.15s ease;\n\n  &:hover {\n    background: $lux-surface-muted;\n    color: $lux-text-primary;\n  }\n}\n\n// ── Breadcrumb ────────────────────────────────────────────────────────────────\n.breadcrumb {\n  display: flex;\n  align-items: center;\n  gap: $lux-space-1; // 6px (Figma)\n  min-width: 0;\n  overflow: hidden;\n}\n\n.breadcrumbHome {\n  display: inline-flex;\n  align-items: center;\n  color: $lux-primary; // dark/filled home marker (matches nav active state)\n  flex-shrink: 0;\n}\n\n.breadcrumbSep {\n  width: 3px;\n  height: 3px;\n  border-radius: 50%;\n  background: $lux-text-tertiary;\n  flex-shrink: 0;\n}\n\n.breadcrumbItem,\n.breadcrumbLink {\n  font-size: 12px; // Label/X-Small (Figma)\n  font-weight: 500;\n  line-height: 16px;\n  color: $lux-text-secondary;\n  text-decoration: none;\n  white-space: nowrap;\n}\n\n.breadcrumbLink:hover {\n  color: $lux-text-primary;\n}\n\n.breadcrumbCurrent {\n  color: $lux-text-primary;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n// ── Actions ───────────────────────────────────────────────────────────────────\n.action {\n  display: inline-flex;\n  align-items: center;\n  gap: $lux-space-1;\n  // No fixed height: the row stays 16px tall (text + 16px icon) so topbar text\n  // sits exactly 16px from the top edge (matches the Figma header row).\n  padding: 0 8px;\n  border: none;\n  border-radius: $lux-radius;\n  background: transparent;\n  color: $lux-primary; // Reload / Notifications = primary green (Figma)\n  font-family: inherit;\n  font-size: 12px; // Label/X-Small (Figma)\n  font-weight: 500;\n  cursor: pointer;\n  transition: background 0.15s ease, color 0.15s ease;\n\n  svg {\n    color: $lux-primary;\n    transition: color 0.15s ease;\n  }\n\n  &:hover {\n    background: $lux-surface-muted;\n    color: $lux-primary-600;\n\n    svg {\n      color: $lux-primary-600;\n    }\n  }\n}\n\n.updated {\n  display: inline-flex;\n  align-items: center;\n  gap: $lux-space-1;\n  padding: 0 8px;\n  color: $lux-text-secondary; // \"Updated …\" = text/secondary (Figma)\n  font-size: 12px; // Label/X-Small (Figma)\n  font-weight: 500;\n  white-space: nowrap;\n\n  svg {\n    color: $lux-icon-secondary;\n  }\n}\n\n.actionLabel {\n  white-space: nowrap;\n}\n\n.bellWrap {\n  position: relative;\n  display: inline-flex;\n}\n\n.bellBadge {\n  position: absolute;\n  top: -5px;\n  right: -6px;\n  min-width: 15px;\n  height: 15px;\n  padding: 0 3px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 9999px;\n  background: $lux-accent;\n  color: #fff;\n  font-size: 9px;\n  font-weight: 700;\n  line-height: 1;\n}\n\n// ── Responsive ────────────────────────────────────────────────────────────────\n@media (max-width: $lux-bp-collapse) {\n  .menuToggle {\n    display: inline-flex;\n  }\n\n  // Collapse action labels to icons on small screens; keep the \"Updated\" text out.\n  .actionLabel {\n    display: none;\n  }\n\n  .updated {\n    display: none;\n  }\n\n  .topbar {\n    border-radius: 0;\n    padding: $lux-space-4 $lux-space-4 0; // keep the 16px inset on mobile too\n  }\n}\n","// =============================================================================\n// Lumiere Ivory — Supplier Portal design tokens\n// -----------------------------------------------------------------------------\n// Single source of truth for the new theme, mapped 1:1 from the Figma variables\n// (Supplier V1 · node 84-45990). This is the foundation of the theme migration:\n// new/migrated components consume the `--lux-*` custom properties emitted by the\n// `lux-tokens` mixin (applied on the shell root in PortalLayout.module.scss), or\n// the `$lux-*` Sass variables directly inside the layout modules.\n//\n//   Figma variable            ->  token\n//   Primary/500 *             ->  $lux-primary\n//   Background/Surface/Default->  $lux-surface\n//   Stroke/Primary            ->  $lux-stroke\n//   Spacing/4 (8)             ->  $lux-space-2\n//   Radius/8                  ->  $lux-radius-lg\n// =============================================================================\n\n// ── Brand ────────────────────────────────────────────────────────────────────\n$lux-primary:        #1b3a34; // Primary/500 *\n$lux-primary-600:    #17322d; // Primary/600 (hover / pressed)\n$lux-primary-200:    #bdd3ce; // Primary/200 (tint)\n$lux-on-primary:     #ffffff;\n\n// ── Text ─────────────────────────────────────────────────────────────────────\n$lux-text-primary:   #0a0a0a; // Text/Primary\n$lux-text-secondary: #737373; // Text/Secondary\n$lux-text-tertiary:  #a3a3a3; // Text/Tertiery\n\n// ── Icon ─────────────────────────────────────────────────────────────────────\n$lux-icon-primary:   #0a0a0a; // Icon/Primary\n$lux-icon-secondary: #6f7173; // Icon/Secondary\n$lux-icon-tertiary:  #8a8c8f; // Icon/Tertiery\n\n// ── Surface ──────────────────────────────────────────────────────────────────\n$lux-surface:        #ffffff; // Background/Surface/Default\n$lux-surface-muted:  #f9f8f7; // Background/Surface/Neutral Lv1\n$lux-page-bg:        #f3f2f0; // page bg behind the floating panels\n\n// ── Stroke ───────────────────────────────────────────────────────────────────\n$lux-stroke:         #f0efee;                  // Stroke/Primary\n$lux-stroke-strong:  #dfdfdf;                  // Stroke/Tertiery\n$lux-panel-border:   rgba(115, 124, 127, 0.14); // floating panel hairline\n\n// ── Accent (danger / destructive) ────────────────────────────────────────────\n$lux-accent:         #ff5a00; // Orange/500 *\n$lux-accent-600:     #e85200; // Orange/600\n\n// ── Radius ───────────────────────────────────────────────────────────────────\n$lux-radius:         4px; // Radius/4 (controls, nav items)\n$lux-radius-lg:      8px; // Radius/8 (panels, cards)\n\n// ── Spacing ──────────────────────────────────────────────────────────────────\n$lux-space-1:        6px;  // Spacing/3\n$lux-space-2:        8px;  // Spacing/4\n$lux-space-3:        12px; // Spacing/5\n$lux-space-4:        16px;\n$lux-space-5:        20px;\n$lux-shell-gap:      8px;  // gap between the two floating panels\n\n// ── Elevation ────────────────────────────────────────────────────────────────\n$lux-shadow-xs:      0 1px 2px rgba(10, 13, 20, 0.03); // regular-shadow/x-small\n\n// ── Geometry ─────────────────────────────────────────────────────────────────\n$lux-sidebar-width:  270px;\n$lux-topbar-height:  64px;\n$lux-bp-collapse:    1139.98px; // below this the sidebar becomes a drawer\n\n// ── Typography ───────────────────────────────────────────────────────────────\n// Inter Tight only — no fallback of any kind (not even the generic sans-serif).\n$lux-font: 'Inter Tight';\n// type scale (size / weight / line-height) from the Figma text styles\n$lux-text-body:    14px; // Label/Small         500 / 20\n$lux-text-label:   12px; // Label/X-Small       500 / 16\n$lux-text-title-h5: 24px; // Title/H-5          600 / 32\n\n// -----------------------------------------------------------------------------\n// Emit the palette as CSS custom properties so migrated components can theme\n// against `var(--lux-*)` instead of hard-coding hexes. Applied once on the\n// shell root (.shell) — values cascade to every descendant.\n// -----------------------------------------------------------------------------\n@mixin lux-tokens {\n  --lux-primary: #{$lux-primary};\n  --lux-primary-600: #{$lux-primary-600};\n  --lux-primary-200: #{$lux-primary-200};\n  --lux-on-primary: #{$lux-on-primary};\n\n  --lux-text-primary: #{$lux-text-primary};\n  --lux-text-secondary: #{$lux-text-secondary};\n  --lux-text-tertiary: #{$lux-text-tertiary};\n\n  --lux-icon-primary: #{$lux-icon-primary};\n  --lux-icon-secondary: #{$lux-icon-secondary};\n  --lux-icon-tertiary: #{$lux-icon-tertiary};\n\n  --lux-surface: #{$lux-surface};\n  --lux-surface-muted: #{$lux-surface-muted};\n  --lux-page-bg: #{$lux-page-bg};\n\n  --lux-stroke: #{$lux-stroke};\n  --lux-stroke-strong: #{$lux-stroke-strong};\n  --lux-panel-border: #{$lux-panel-border};\n\n  --lux-accent: #{$lux-accent};\n  --lux-accent-600: #{$lux-accent-600};\n\n  --lux-radius: #{$lux-radius};\n  --lux-radius-lg: #{$lux-radius-lg};\n\n  --lux-space-1: #{$lux-space-1};\n  --lux-space-2: #{$lux-space-2};\n  --lux-space-3: #{$lux-space-3};\n  --lux-space-4: #{$lux-space-4};\n\n  --lux-shadow-xs: #{$lux-shadow-xs};\n  --lux-sidebar-width: #{$lux-sidebar-width};\n  --lux-topbar-height: #{$lux-topbar-height};\n\n  --lux-font: #{$lux-font};\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"topbar": `Topbar_topbar__lz+So`,
	"left": `Topbar_left__JY1XN`,
	"right": `Topbar_right__S+jT9`,
	"menuToggle": `Topbar_menuToggle__PhqUB`,
	"breadcrumb": `Topbar_breadcrumb__gh-PJ`,
	"breadcrumbHome": `Topbar_breadcrumbHome__4GDod`,
	"breadcrumbSep": `Topbar_breadcrumbSep__Wgn2I`,
	"breadcrumbItem": `Topbar_breadcrumbItem__rUG9Z`,
	"breadcrumbLink": `Topbar_breadcrumbLink__ZKrC1`,
	"breadcrumbCurrent": `Topbar_breadcrumbCurrent__siwQT`,
	"action": `Topbar_action__fWuOa`,
	"updated": `Topbar_updated__0yZi9`,
	"actionLabel": `Topbar_actionLabel__P+Ti3`,
	"bellWrap": `Topbar_bellWrap__mtyDC`,
	"bellBadge": `Topbar_bellBadge__2UeDk`
};
export default ___CSS_LOADER_EXPORT___;
